/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Carer } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import type {
  IDType,
  ResultType,
  UseFindItemProps,
  UseFindItemReturn
} from './useFindItem'

export const getCarerName = (carer: Carer | undefined) => {
  if (!carer?.name) return ''
  return `${carer.name.first ?? ''} ${carer.name.last ?? ''}`.trim()
}

export const getCarer = (carers: Carer[], id: string): Carer | undefined => {
  const carer = carers?.find((carer) => carer.id === id)

  return carer
}

export const getCarers = (carers: Carer[], id: string[]): Carer[] => {
  throw new Error('not implemented')
}

/**
 * @deprecated
 * use useUser and useUsersList
 */
const useCarers = <ID extends IDType>(
  props: UseFindItemProps<ID>
): UseFindItemReturn<Carer, ID> => {
  const { id } = props
  const carers = useSelector(
    (state: { data: { carers: Carer[] } }) => state.data.carers
  )

  const getResult = () => {
    if (!id) {
      return undefined
    }

    if (typeof id === 'string') {
      return getCarer(carers, id)
    }

    return getCarers(carers, id)
  }

  return {
    result: getResult() as ResultType<Carer, ID>,
    all: carers,
    active: []
  }
}

export default useCarers
